const ok = (value) => ({ ok: true, value });
const err = (error) => ({ ok: false, error });
const formatPrefix = (nodeName) => `[${nodeName}]`;
export function getStepAtCursor(args) {
    const { nodeName, currentThreadIndex, currentStepCounter, threadSteps, } = args;
    if (!threadSteps) {
        return err({
            code: 'missing_thread_steps',
            message: `${formatPrefix(nodeName)} No steps found for currentThreadIndex ${currentThreadIndex}`,
            details: { currentThreadIndex },
        });
    }
    const step = threadSteps[currentStepCounter];
    if (!step) {
        return err({
            code: 'step_oob',
            message: `${formatPrefix(nodeName)} No step found at counter ${currentStepCounter} for thread ${currentThreadIndex}`,
            details: {
                currentThreadIndex,
                currentStepCounter,
                threadStepsLength: threadSteps.length,
            },
        });
    }
    return ok(step);
}
